import { format } from 'date-fns';
import { Calendar } from 'lucide-react';

import type { Workstream } from '@/project-management/entities/workstream';
import { formatPercentage } from '@/utils/format/number';

export type WorkstreamPreviewProps = {
  workstream: Pick<Workstream, 'name' | 'endDate' | 'progress'>;
};

export function WorkstreamPreview({ workstream }: WorkstreamPreviewProps) {
  return (
    <div className="space-y-2 text-sm text-gray-500">
      <div className="flex justify-between gap-2">
        <div className="truncate font-medium text-gray-700">
          {workstream.name}
        </div>
        <div className="flex shrink-0 items-center gap-1">
          <Calendar className="size-4" />
          <span>{format(workstream.endDate, 'MMM d, yyyy')}</span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-full flex-1">
          <div className="h-2 flex-1 rounded-full bg-gray-100">
            <div
              className="h-2 rounded-full bg-primary-400"
              style={{
                width: `${workstream.progress * 100}%`,
              }}
            />
          </div>
        </div>
        <div className="shrink-0">
          {formatPercentage(workstream.progress, 0, 0)}
        </div>
      </div>
    </div>
  );
}
